import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

export const publishedConnectionSortOptions: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  'name': SortOptions.name,
  'owner': SortOptions.owner,
  'containerName': SortOptions.containerName,
  'updated': SortOptions.updated,
};

export const publishedConnectionTableSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
};

export const publishedConnectionColumnSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
};